import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { APP } from '@/constants/testIds';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const sid = hash.match(/session_id=([^&]+)/)?.[1];
    if (!sid) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id: sid });
        if (data.session_token) localStorage.setItem('sws_token', data.session_token);
        setUser?.(data.user);
        // strip hash and route into app
        window.history.replaceState(null, '', '/');
        const dest = data.user?.role === 'admin' ? '/admin' : '/app';
        navigate(dest, { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error('Auth exchange failed', e);
        navigate('/login');
      }
    })();
    
  }, []);

  return (
    <div data-testid={APP.authCallback} className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="logo-mark mx-auto mb-4">S</div>
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-[color:var(--text-secondary)] blink">
          Establishing secure session…
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
